export class UpdateCloudEnvironmentResponse {
    customerId?: string;
    accountId?: string;
    environmentId?: string;
    connectAccountId?: string;
    isAvailable?: boolean;
    isEnabled?: boolean;
    inMaintenanceMode?: boolean;
    statusMessage?: string;
    version?: string;
    deploymentType?: string;
}